import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import LotteryPromoWidget from './LotteryPromoWidget.component';
import { showNotification } from 'Store/Notification/Notification.action';
import { isSignedIn } from 'Util/Auth';
import { fetchMutation } from 'Util/Request';
import LotteryPromoQuery from 'Query/LotteryPromo.query';

class LotteryPromoWidgetContainer extends PureComponent {
    state = {
        isSubmitting: false,
        error: null,
        resetTrigger: 0
    };

    handleSubmit = (data) => {
        const { showNotification } = this.props;
        this.setState({ isSubmitting: true, error: null });

        fetchMutation(LotteryPromoQuery.getSubmitStoreReceiptMutation(data))
            .then((res) => {
                const { submitStoreReceipt } = res;
                if (submitStoreReceipt.success) {
                    showNotification('success', __('The receipt was submitted successfully'));
                    // Clear the form by incrementing the resetTrigger
                    this.setState((prevState) => ({
                        resetTrigger: prevState.resetTrigger + 1,
                        isSubmitting: false
                    }));
                } else {
                    this.setState({ error: submitStoreReceipt.message, isSubmitting: false });
                    showNotification('error', submitStoreReceipt.message);
                }
            })
            .catch((err) => {
                this.setState({ error: 'Submission error.', isSubmitting: false });
                showNotification('error', 'Submission error.');
            });
    };

    render() {
        const { title, lotteryName, termsandconditions_link} = this.props;
        const { isSubmitting, error, resetTrigger } = this.state;
        const signedIn = isSignedIn();

        return (
            <LotteryPromoWidget
                title={title}
                lotteryName={lotteryName}
                termsandconditions_link = {termsandconditions_link}
                isSubmitting={isSubmitting}
                error={error}
                onSubmit={this.handleSubmit}
                isSignedIn={signedIn}
                resetTrigger={resetTrigger}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

export default connect(null, mapDispatchToProps)(LotteryPromoWidgetContainer);
